document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('[data-bn-hero-slider]');
  if (!slider) return;

  const slides = Array.from(slider.querySelectorAll('[data-bn-slide]'));
  let current = 0;
  let autoplay = null;
  let touchStartX = 0;
  let touchEndX = 0;

  function syncDots() {
    slides.forEach((slide, slideIndex) => {
      const dots = slide.querySelectorAll('[data-bn-dot]');
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', slideIndex === current && dotIndex === current);
      });
    });
  }

  function goTo(index) {
    if (index === current) return;

    slides[current].classList.remove('is-active');
    current = (index + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    syncDots();
  }

  function nextSlide() {
    goTo(current + 1);
  }

  function prevSlide() {
    goTo(current - 1);
  }

  function startAutoplay() {
    stopAutoplay();
    autoplay = setInterval(nextSlide, 4000);
  }

  function stopAutoplay() {
    if (autoplay) {
      clearInterval(autoplay);
      autoplay = null;
    }
  }

  slider.addEventListener('click', function (event) {
    const nextBtn = event.target.closest('[data-bn-next]');
    const dotBtn = event.target.closest('[data-bn-dot]');

    if (nextBtn) {
      nextSlide();
      startAutoplay();
      return;
    }

    if (dotBtn) {
      const index = Number(dotBtn.getAttribute('data-bn-dot'));
      goTo(index);
      startAutoplay();
    }
  });

  slider.addEventListener('mouseenter', stopAutoplay);
  slider.addEventListener('mouseleave', startAutoplay);

  slider.addEventListener('touchstart', function (e) {
    touchStartX = e.changedTouches[0].clientX;
  }, { passive: true });

  slider.addEventListener('touchend', function (e) {
    touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX - touchEndX;

    if (Math.abs(diff) > 40) {
      if (diff > 0) {
        nextSlide();
      } else {
        prevSlide();
      }
      startAutoplay();
    }
  }, { passive: true });

  syncDots();
  startAutoplay();
});